<template>
  <div class="entry-detail">
    <div class="main">
      <el-button icon="el-icon-printer" type="text" style="float:right;padding: 0;" @click="clickPrint"></el-button>
      <div id="print">
        <div style="text-align:center;margin-bottom:16px;font-weight:600;font-size:18px">记账凭证</div>
        <el-descriptions :column=3>
          <el-descriptions-item label="编号">{{account ? ojdtData.accountCode : ojdtData.code}}</el-descriptions-item>
          <el-descriptions-item label="序号">{{ojdtData.offOjdtId}}</el-descriptions-item>
          <el-descriptions-item label="发生日期">{{ojdtData.ojdtDate | filter_handleDate}}</el-descriptions-item>
          <el-descriptions-item label="所属期间">{{ojdtData.tbperd}}</el-descriptions-item>
          <el-descriptions-item label="活动详情">
            <a @click="goProject(ojdtData)" class="link">{{ojdtData.ofoworkName}}</a>
          </el-descriptions-item>
        </el-descriptions>
        <table border="1" cellSpacing="0" style="width:100%;border: 1px solid #abc8df">
          <tr style="background: #e1f0fc" height="30">
            <th rowspan="2" width="32">行</th>
            <th rowspan="2" width="20%">摘要</th>
            <th rowspan="2">会计科目</th>
            <th colspan="13">借方金额</th>
            <th colspan="13">贷方金额</th>
          </tr>
          <tr style="background: #e1f0fc" height="30">
            <th width="16">百</th>
            <th width="16" class="border-right">十</th>
            <th width="16" class="border-left">亿</th>
            <th width="16">千</th>
            <th width="16" class="border-right">百</th>
            <th width="16" class="border-left">十</th>
            <th width="16">万</th>
            <th width="16" class="border-right">千</th>
            <th width="16" class="border-left">百</th>
            <th width="16">十</th>
            <th width="16" class="border-right">元</th>
            <th width="16" class="border-left">角</th>
            <th width="16">分</th>
            <th width="16">百</th>
            <th width="16" class="border-right">十</th>
            <th width="16" class="border-left">亿</th>
            <th width="16">千</th>
            <th width="16" class="border-right">百</th>
            <th width="16" class="border-left">十</th>
            <th width="16">万</th>
            <th width="16" class="border-right">千</th>
            <th width="16" class="border-left">百</th>
            <th width="16">十</th>
            <th width="16" class="border-right">元</th>
            <th width="16" class="border-left">角</th>
            <th width="16">分</th>
          </tr>
          <tr height="60" v-for="(item, index) in ojdtacctList" :key="index" v-if="item.debit1 || item.credit1">
            <td align="center">{{index + 1}}</td>
            <td style="padding:8px">{{item.remarks}}</td>
            <td style="padding:8px">
              {{item.acctName + ' : ' +  item.acctCode}}
            </td>
            <td align="right">{{item.debit1[item.debit1.length - 13]}}</td>
            <td class="border-right" align="right">{{item.debit1[item.debit1.length - 12]}}</td>
            <td class="border-left" align="right">{{item.debit1[item.debit1.length - 11]}}</td>
            <td align="right">{{item.debit1[item.debit1.length - 10]}}</td>
            <td class="border-right" align="right">{{item.debit1[item.debit1.length - 9]}}</td>
            <td class="border-left" align="right">{{item.debit1[item.debit1.length - 8]}}</td>
            <td align="right">{{item.debit1[item.debit1.length - 7]}}</td>
            <td class="border-right" align="right">{{item.debit1[item.debit1.length - 6]}}</td>
            <td class="border-left" align="right">{{item.debit1[item.debit1.length - 5]}}</td>
            <td align="right">{{item.debit1[item.debit1.length - 4]}}</td>
            <td class="border-right" align="right">{{item.debit1[item.debit1.length - 3]}}</td>
            <td class="border-left" align="right">{{item.debit1[item.debit1.length - 2]}}</td>
            <td align="right">{{item.debit1[item.debit1.length - 1]}}</td>
            <td align="right">{{item.credit1[item.credit1.length - 13]}}</td>
            <td class="border-right" align="right">{{item.credit1[item.credit1.length - 12]}}</td>
            <td class="border-left" align="right">{{item.credit1[item.credit1.length - 11]}}</td>
            <td align="right">{{item.credit1[item.credit1.length - 10]}}</td>
            <td class="border-right" align="right">{{item.credit1[item.credit1.length - 9]}}</td>
            <td class="border-left" align="right">{{item.credit1[item.credit1.length - 8]}}</td>
            <td align="right">{{item.credit1[item.credit1.length - 7]}}</td>
            <td class="border-right" align="right">{{item.credit1[item.credit1.length - 6]}}</td>
            <td class="border-left" align="right">{{item.credit1[item.credit1.length - 5]}}</td>
            <td align="right">{{item.credit1[item.credit1.length - 4]}}</td>
            <td class="border-right" align="right">{{item.credit1[item.credit1.length - 3]}}</td>
            <td class="border-left" align="right">{{item.credit1[item.credit1.length - 2]}}</td>
            <td align="right">{{item.credit1[item.credit1.length - 1]}}</td>
          </tr>
          <tr height="60" style="background: #e1f0fc">
            <td colspan="3" style="padding-left:8px;font-weight:600;">合计：{{ojdtData.totalText}}</td>

            <td align="right">{{ojdtData.debitTotal1.length >= 13 ? ojdtData.debitTotal1[ojdtData.debitTotal1.length - 13]:''}}</td>
            <td class="border-right" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 12]}}</td>
            <td class="border-left" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 11]}}</td>
            <td align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 10]}}</td>
            <td class="border-right" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 9]}}</td>
            <td class="border-left" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 8]}}</td>
            <td align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 7]}}</td>
            <td class="border-right" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 6]}}</td>
            <td class="border-left" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 5]}}</td>
            <td align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 4]}}</td>
            <td class="border-right" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 3]}}</td>
            <td class="border-left" align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 2]}}</td>
            <td align="right">{{ojdtData.debitTotal1[ojdtData.debitTotal1.length - 1]}}</td>



            <td align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 13]}}</td>
            <td class="border-right" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 12]}}</td>
            <td class="border-left" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 11]}}</td>
            <td align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 10]}}</td>
            <td class="border-right" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 9]}}</td>
            <td class="border-left" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 8]}}</td>
            <td align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 7]}}</td>
            <td class="border-right" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 6]}}</td>
            <td class="border-left" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 5]}}</td>
            <td align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 4]}}</td>
            <td class="border-right" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 3]}}</td>
            <td class="border-left" align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 2]}}</td>
            <td align="right">{{ojdtData.creditTotal1[ojdtData.creditTotal1.length - 1]}}</td>
          </tr>
        </table>

        <el-descriptions :column=3 style="margin-top:16px">
          <el-descriptions-item label="审核人">{{ojdtData.checkUserName}}</el-descriptions-item>
          <el-descriptions-item label="记账人">{{ojdtData.accountUserName}}</el-descriptions-item>
          <el-descriptions-item label="注释">{{ojdtData.remarks}}</el-descriptions-item>
          <el-descriptions-item label="制单">{{ojdtData.ofrthingName}}</el-descriptions-item>
        </el-descriptions>
        <div v-if="workDetail && workDetail.productsList && workDetail.productsList.length > 0" class="print-block print-product-view" style="margin-top: 15px">
          <productView :key="productViewKey" style="width:100%" :ofoFlowWork="workDetail.ofoFlowWork || {}" :ofoFlowDeal="workDetail.ofoFlowDeal || {}" :productsList="workDetail.productsList || []" :thingsList="[]" :workConfig="workDetail.workConfig || {}" />
        </div>
        <div v-if="fileList && fileList.length > 0" class="print-block print-file-table" style="margin-top: 15px">
          <el-table
            :data="fileList"
            style="width: 100%;"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
            ref="table"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="name"
              label="附件类型">
            </el-table-column>
            <el-table-column
              prop="remarks"
              label="上传要求及说明">
            </el-table-column>
            <el-table-column
              prop="type"
              label="文件上传">
              <template slot-scope="scope">
                <!-- 文件列表 -->
                <fileList :fileList="scope.row.fileList" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="approvalList && approvalList.length > 0" class="print-block print-approval-table" style="margin-top: 15px">
          <el-table
            border
            :data="approvalList"
            style="width: 100%"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}">
            <el-table-column
              label="序号"
              width="80">
              <template slot-scope="scope">
                {{scope.row.osappId}}-{{scope.row.order}}
              </template>
            </el-table-column>
            <el-table-column
              prop="ofrthingName"
              label="审批人"
              align="center">
            </el-table-column>
            <el-table-column
              prop="appstatus"
              label="审批状态"
              align="center">
              <template slot-scope="scope">
                <DictTag :options="dropDown.appStatus" :value="scope.row.appstatus" v-if="scope.row.steptype == '1'"/>
                <span v-if="scope.row.steptype == '2'">抄送</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              align="center">
              <template slot-scope="scope">
                {{scope.row.createTime | filter_handleDateTime}}
              </template>
            </el-table-column>
            <el-table-column
              label="审批时间"
              align="center">
              <template slot-scope="scope">
                {{scope.row.updateTime | filter_handleDateTime}}
              </template>
            </el-table-column>
            <el-table-column
              prop="remarks"
              label="审批意见">
              <template slot-scope="scope">
                <div id="editor-content-view" class="editor-content-view" v-html="scope.row.remarks"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import url from '@/config/url'
import {toChies} from '@/utils/toChies'
import ProductView from "@/components/project/activity/productView.vue";
import handleWorkConfigList from "@/utils/handleWorkConfigList";
import {mapState} from "vuex";
  export default {
    components: {ProductView},
    computed: {
      ...mapState({
        dropDown: state => state.dropDown.dropDown
      }),
    },
    data() {
      return {
        offOjdtId: this.$route.params.offOjdtId,
        nbzzId: this.$route.params.nbzzId,
        ojdtData: {
          debitTotal1: '',
          creditTotal1: '',
        },
        workDetail: {},
        fileList:[],
        approvalList:[],
        ojdtacctList: [],
        account: this.$route.query.account,
        productViewKey: 1,
      }
    },
    async created () {
      if(!this.dropDown.appStatus) {
        this.$http.get(url.getDataList, {params: {type: 'buss_app_status' }}).then(res => {
          this.$store.commit('setAppStatus', res.data.data)
        })
      }
      this.getdata();
      // console.log(toChies(0.00));
      // this.numToArr(11290.1)
    },
    methods: {
      clickPrint() {
        this.$nextTick(() => {
          const printNode = document.getElementById('print')
          if(!printNode) return

          const cloneNode = printNode.cloneNode(true)
          this.handlePrintTable(cloneNode)

          const iframe = document.createElement('iframe')
          iframe.style.position = 'fixed'
          iframe.style.left = '-10000px'
          iframe.style.top = '0'
          iframe.style.width = '1120px'
          iframe.style.height = '800px'
          iframe.style.border = '0'
          document.body.appendChild(iframe)

          const printWindow = iframe.contentWindow
          const printDocument = printWindow.document
          let printed = false
          const removeIframe = () => {
            if(iframe.parentNode) {
              document.body.removeChild(iframe)
            }
          }
          const doPrint = () => {
            if(printed) return
            printed = true
            printWindow.focus()
            printWindow.onafterprint = removeIframe
            printWindow.print()
            setTimeout(removeIframe, 3000)
          }

          iframe.onload = () => {
            setTimeout(doPrint, 200)
          }
          printDocument.open()
          printDocument.write(`
            <!DOCTYPE html>
            <html>
              <head>
                <title></title>
                ${this.getPrintStyles()}
                <style>${this.getPrintPageStyle()}</style>
              </head>
              <body>${cloneNode.outerHTML}</body>
            </html>
          `)
          printDocument.close()
          setTimeout(doPrint, 1000)
        })
      },
      handlePrintTable(root) {
        root.querySelectorAll('.print-product-view .el-table__expand-column').forEach(item => {
          item.parentNode && item.parentNode.removeChild(item)
        })
        root.querySelectorAll('.print-product-view .el-table__expand-icon').forEach(item => {
          item.parentNode && item.parentNode.removeChild(item)
        })
        root.querySelectorAll('.print-block .el-table__fixed, .print-block .el-table__fixed-right, .print-block .el-table__fixed-right-patch').forEach(item => {
          item.parentNode && item.parentNode.removeChild(item)
        })
        root.querySelectorAll('.print-block colgroup').forEach(item => {
          item.parentNode && item.parentNode.removeChild(item)
        })
        root.querySelectorAll('.print-block .el-table, .print-block .el-table__header-wrapper, .print-block .el-table__body-wrapper, .print-block .el-table__header, .print-block .el-table__body').forEach(item => {
          item.style.width = '100%'
          item.style.overflow = 'visible'
        })
        root.querySelectorAll('.print-block .el-table__body-wrapper').forEach(item => {
          item.style.height = 'auto'
          item.style.maxHeight = 'none'
        })
        root.querySelectorAll('.print-block .cell').forEach(item => {
          item.removeAttribute('style')
        })
        this.setPrintTableWidths(root)
      },
      setPrintTableWidths(root) {
        this.setTableColumnWidths(root.querySelector('.print-file-table'), {
          '序号': 6,
          '附件类型': 16,
          '上传要求及说明': 42,
          '文件上传': 36
        })
        this.setTableColumnWidths(root.querySelector('.print-approval-table'), {
          '序号': 8,
          '审批人': 10,
          '审批状态': 10,
          '创建时间': 16,
          '审批时间': 16,
          '审批意见': 40
        })
        root.querySelectorAll('.print-product-view .el-table').forEach(table => {
          this.setTableColumnWidths(table, null, this.getProductColumnWeight)
        })
      },
      setTableColumnWidths(container, widthMap, weightGetter) {
        if(!container) return

        const headerCells = Array.from(container.querySelectorAll('.el-table__header-wrapper thead th'))
        if(headerCells.length < 1) return

        const weights = headerCells.map(cell => {
          const label = cell.innerText.trim()
          return widthMap ? (widthMap[label] || 10) : weightGetter(label)
        })
        const total = weights.reduce((sum, item) => sum + item, 0)
        if(!total) return

        headerCells.forEach((cell, index) => {
          cell.style.width = `${weights[index] / total * 100}%`
        })
        container.querySelectorAll('.el-table__body-wrapper tbody tr').forEach(row => {
          Array.from(row.children).forEach((cell, index) => {
            if(weights[index]) {
              cell.style.width = `${weights[index] / total * 100}%`
            }
          })
        })
      },
      getProductColumnWeight(label) {
        if(label === '行号') return 4
        if(label.includes('位置')) return 7
        if(label.includes('名称')) return 16
        if(label.includes('规格')) return 10
        if(label === '单位') return 4
        if(label.includes('备注')) return 9
        if(label.includes('时间') || label.includes('日期')) return 9
        if(label.includes('数量')) return 7
        if(label.includes('单价') || label.includes('金额') || label.includes('成本') || label.includes('税额')) return 8
        if(label.includes('税率') || label.includes('票种') || label.includes('结论')) return 6
        if(label.includes('包装')) return 6
        return 8
      },
      getPrintStyles() {
        const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(item => {
          return `<link rel="stylesheet" href="${item.href}">`
        }).join('')
        const styles = Array.from(document.querySelectorAll('style')).map(item => {
          return `<style>${item.innerHTML}</style>`
        }).join('')
        return links + styles
      },
      getPrintPageStyle() {
        return `
          @page {
            size: A4 landscape;
            margin: 8mm;
          }
          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          html,
          body {
            margin: 0;
            padding: 0;
            width: 100%;
          }
          #print {
            width: 100% !important;
            overflow: visible !important;
          }
          #print table {
            border-collapse: collapse;
          }
          #print .print-block {
            width: 100% !important;
            overflow: visible !important;
            page-break-inside: auto;
            break-inside: auto;
          }
          #print .print-block .el-table {
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
            font-size: 9px !important;
          }
          #print .print-block .el-table__header-wrapper {
            width: 100% !important;
            overflow: visible !important;
          }
          #print .print-block .el-table__body-wrapper {
            width: 100% !important;
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
          }
          #print .print-block .el-table__header {
            width: 100% !important;
            table-layout: fixed !important;
          }
          #print .print-block .el-table__body {
            width: 100% !important;
            table-layout: fixed !important;
          }
          #print .print-block th,
          #print .print-block td {
            min-width: 0 !important;
            max-width: none !important;
            padding: 2px !important;
          }
          #print .print-block .cell {
            width: auto !important;
            padding: 0 2px !important;
            white-space: normal !important;
            word-break: break-all !important;
            overflow-wrap: anywhere !important;
            overflow: visible !important;
            text-overflow: clip !important;
            line-height: 1.3 !important;
          }
          #print .print-product-view .el-table {
            font-size: 7px !important;
          }
          #print .print-product-view th,
          #print .print-product-view td {
            padding: 1px !important;
          }
          #print .print-product-view .el-table__expand-column {
            display: none !important;
          }
          #print .print-product-view .el-table__expand-icon {
            display: none !important;
          }
          #print .print-block .el-table__fixed {
            display: none !important;
          }
          #print .print-block .el-table__fixed-right {
            display: none !important;
          }
          #print .print-block .el-table__fixed-right-patch {
            display: none !important;
          }
        `
      },
      numToStr(num) {
        if(num == null || num == 0) {
          return ''
        }else {
          let str = num + ''
          if(str.indexOf('.') == -1) {
            str = str + '.00'
          }else {
            let last = str.substring(str.indexOf('.') + 1, str.length)
            // console.log(last);
            if(last.length == 1) {
              str = str + '0'
            }
          }
          return str.replace('.', '').replace(/\b(0+)/gi,'')
        }

      },
      async getdata() {
        this.$http.get(url.getOffOjdt, {params: {offOjdtId: this.offOjdtId}}).then(res => {
          this.ojdtData = res.data.data.ojdt
          if(this.ojdtData.debitTotal) {
            this.ojdtData.debitTotal1 = this.numToStr(this.ojdtData.debitTotal.toFixed(2))
          }else {
            this.ojdtData.debitTotal1 = '000'
          }
          if(this.ojdtData.creditTotal) {
            this.ojdtData.creditTotal1 = this.numToStr(this.ojdtData.creditTotal.toFixed(2))
          }else {
            this.ojdtData.creditTotal1 = '000'
          }

          this.ojdtData.totalText = toChies( Math.abs(this.ojdtData.creditTotal))
          // this.ojdtData.totalText = toChies(0)
          this.ojdtacctList = res.data.data.ojdtacctList
          this.ojdtacctList.forEach(item => {
            item.debit1 = this.numToStr(item.debit.toFixed(2))
            item.credit1 = this.numToStr(item.credit.toFixed(2))
          })
          this.getWorkInfo()
        })
      },
      async getWorkInfo(){
        const workId = this.ojdtData.ofoworkId
        this.workDetail = {}
        await this.$http.get(url.getOfoFlowWorkByOfoWorkId + workId).then(res => {
          this.workDetail.ofoFlowWork = res.data.data || {}
        })
        if(!this.workDetail.ofoFlowWork || Object.keys(this.workDetail.ofoFlowWork).length < 1 ){
          return
        }
        await this.$http.get(url.getOfoFlowDealById + this.workDetail.ofoFlowWork.ofodealId).then(res => {
          this.workDetail.ofoFlowDeal = res.data.data || {}
        })
        // if(this.workDetail.ofoFlowWork.checkConfig) {
        //   await this.$http.get(url.getItemWorkConfig, {params: {
        //       ofoflowworkId: row.workDetail.ofoFlowWork.ofoFlowWorkId
        //     }}).then(res => {
        //     if(res.data.code == 200) {
        //       this.workDetail.workConfig = res.data.data
        //     }
        //   })
        // }else {
        //   this.workDetail.workConfig = {}
        // }
        if(this.workDetail.ofoFlowWork.kindtype && this.workDetail.ofoFlowWork.workkindmanagetype != '0') {
          await this.$http.get(url.getWorkResAndThingList, {params: {
              ofoWorkId: workId,
              pageNum: 1,
              pageSize: 2000,
              type: '1'
            }}).then(res => {
            if(res.data.code == 200) {
              let productsList = handleWorkConfigList(this.workDetail.ofoFlowWork.checkConfig, res.data.data.list, this.workDetail.workConfig)
              productsList.forEach(item => {
                item.bomId = item.bomId ? Number(item.bomId) : null
              })
              this.workDetail.productsList = productsList
            }
          })
        }
        this.productViewKey = this.productViewKey + 1
        await this.$http.get(url.getWork, {params: {ofoWorkId: workId, isShare: '1'}}).then(res => {
          // console.log(res);
          if(res.data.code == 200) {
            console.log(res.data.data)
            this.fileList = res.data.data.files
            this.approvalList = res.data.data.appStepList
          }
        })
      },
      goProject(item) {
        this.$http.get(url.getWorkJumpId, {params: {ofoWorkId: item.ofoworkId}}).then(res => {
          // console.log(res);
          if(res.data.code == 200) {
            this.$router.push({
              path: '/project/' + res.data.data.ofoItemId,
            });
            this.$store.commit("setJumpData", {...res.data.data, turn: true})
            let obj = {
              path: "/project/" + res.data.data.ofoItemId,
              name: "proDetail",
              label: "项目详情",
              ofoItemId: res.data.data.ofoItemId,
              children: []
            };
            this.$store.commit('setSecondMenu', [])
            this.$store.commit("selectMenu", obj);
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
.entry-detail {
  /* padding: 16px; */
  .main {
    background: #FFFFFF;
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,0.5);
    border-radius: 11px;
    padding: 16px;
    position: relative;
    .border-right {
      border-right: 1px solid #f6b8b4;
    }
    .border-left {
      border-left: 1px solid #f6b8b4;
    }
  }
}

@media print {
  @page {
    size: A4 landscape;
    margin: 10mm;
  }

  ::v-deep #print {
    width: 100% !important;
  }

  ::v-deep #print .print-block {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  ::v-deep #print .print-block .el-table {
    overflow: visible !important;
    width: 100% !important;
    table-layout: auto !important;
  }

  ::v-deep #print .print-block .el-table__header-wrapper,
  ::v-deep #print .print-block .el-table__body-wrapper {
    overflow: visible !important;
    width: 100% !important;
  }

  ::v-deep #print .print-block .el-table__header,
  ::v-deep #print .print-block .el-table__body {
    width: 100% !important;
  }

  ::v-deep #print .print-block col {
    width: auto !important;
  }

  ::v-deep #print .print-block .el-table__fixed,
  ::v-deep #print .print-block .el-table__fixed-right,
  ::v-deep #print .print-block .el-table__fixed-right-patch {
    display: none !important;
  }

  ::v-deep #print .print-block .el-table__cell {
    white-space: normal !important;
    word-break: break-word;
  }

  ::v-deep #print .print-product-view {
    width: 100% !important;
    overflow: visible !important;
  }

  ::v-deep #print .print-file-table,
  ::v-deep #print .print-approval-table {
    width: 100% !important;
    overflow: visible !important;
  }

  ::v-deep #print .print-file-table .el-table,
  ::v-deep #print .print-approval-table .el-table {
    overflow: visible !important;
    width: 100% !important;
    table-layout: fixed !important;
  }

  ::v-deep #print .print-file-table .el-table__header-wrapper,
  ::v-deep #print .print-file-table .el-table__body-wrapper,
  ::v-deep #print .print-approval-table .el-table__header-wrapper,
  ::v-deep #print .print-approval-table .el-table__body-wrapper {
    overflow: visible !important;
    width: 100% !important;
  }

  ::v-deep #print .print-file-table .el-table .el-table__fixed,
  ::v-deep #print .print-file-table .el-table .el-table__fixed-right,
  ::v-deep #print .print-file-table .el-table .el-table__fixed-right-patch,
  ::v-deep #print .print-approval-table .el-table .el-table__fixed,
  ::v-deep #print .print-approval-table .el-table .el-table__fixed-right,
  ::v-deep #print .print-approval-table .el-table .el-table__fixed-right-patch {
    display: none !important;
  }

  ::v-deep #print .print-file-table .el-table .el-table__cell,
  ::v-deep #print .print-approval-table .el-table .el-table__cell {
    white-space: normal !important;
    word-break: break-word;
    font-size: 10px;
  }

  ::v-deep #print .print-file-table .el-table .el-table__expanded-cell .el-table,
  ::v-deep #print .print-approval-table .el-table .el-table__expanded-cell .el-table {
    margin-left: 0 !important;
  }
}
</style>
